import { apiRequest } from "./api.client";

export interface DeviceCheckResponse {
  trusted: boolean;
  otp_sent: boolean;
}

export interface DeviceInfo {
  device_id: string;
  name: string | null;
  os: string | null;
  browser: string | null;
  platform: string | null; // computed "Browser on OS" display string from backend
  trusted: boolean;
  first_seen_at: string;
  last_seen_at: string;
  is_current: boolean;
}

export const DeviceAPI = {
  check: (device_id: string, user_agent?: string, force_resend = false) =>
    apiRequest<DeviceCheckResponse>("/auth/devices/check", {
      method: "POST",
      body: JSON.stringify({ device_id, user_agent: user_agent ?? navigator.userAgent, force_resend }),
    }),

  verify: (device_id: string, code: string) =>
    apiRequest<{ detail: string }>("/auth/devices/verify", {
      method: "POST",
      body: JSON.stringify({ device_id, code }),
    }),

  list: () => apiRequest<DeviceInfo[]>("/auth/devices", { method: "GET" }),

  rename: (device_id: string, name: string) =>
    apiRequest<DeviceInfo>(`/auth/devices/${device_id}`, {
      method: "PATCH",
      body: JSON.stringify({ name }),
    }),

  remove: (device_id: string) =>
    apiRequest<{ detail: string }>(`/auth/devices/${device_id}`, {
      method: "DELETE",
    }),

  signOutAll: () =>
    apiRequest<{ detail: string }>("/auth/sign-out-all", {
      method: "POST",
    }),
};
